import type { SelectedItem, SharedComponentSelectionContext } from '../Components/AppArtifactPanel';
import type { ReactCodeComponentModel } from '../../../api/api';
import type { UserInterfaceChatArtifactContext } from '../Hooks/useUserInterfaceChatAdapter';
import type { Bundle } from '../Models/Bundle';
import { ComponentTypes } from '../Models/ComponentTypes';
import type { IComponentModel } from '../Models/IComponentModel';
import { type ComponentPath, resolveSelectedComponent } from './ComponentTreeUtils';

export function getSelectedComponentArtifactContext(
	bundle: Bundle | null,
	selectedItem: SelectedItem | null,
	selectedComponentPath: ComponentPath | null,
	selectedSharedComponentContext?: SharedComponentSelectionContext | null,
	components: ReactCodeComponentModel[] = [],
): Pick<UserInterfaceChatArtifactContext, 'componentId' | 'componentPath' | 'reactComponentId' | 'reactComponentName' | 'reactComponentHostState'> {
	if (!bundle || !selectedItem || !selectedComponentPath) {
		return {};
	}

	const component = resolveSelectedComponent(bundle, selectedItem, selectedComponentPath, selectedSharedComponentContext).component;
	if (!component) {
		return {};
	}

	if (component.Type !== ComponentTypes.ReactComponentHost) {
		return {
			componentId: component.Id,
			componentPath: JSON.stringify(selectedComponentPath),
		};
	}

	const reactComponentName = (component as IComponentModel & { ComponentName?: string }).ComponentName;
	const descriptor = reactComponentName
		? components.find((candidate) => candidate.name === reactComponentName)
		: components.find((candidate) => candidate.id === component.Id);
	return {
		componentId: component.Id,
		componentPath: JSON.stringify(selectedComponentPath),
		...(descriptor?.name ? { reactComponentName: descriptor.name } : {}),
		...(descriptor ? { reactComponentId: descriptor.id } : {}),
		reactComponentHostState: descriptor ? 'Bound' : 'Unassigned',
	};
}
